import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ShieldCheck, Flame } from 'lucide-react'
import { cars, brl, km, minParcela, STATUS } from '../data.js'

const filtros = ['Todos', 'Hatch', 'Sedã', 'SUV']

export default function Catalogo() {
  const [filtro, setFiltro] = useState('Todos')
  const lista = cars.filter((c) => filtro === 'Todos' || c.carroceria === filtro)

  return (
    <main className="mx-auto max-w-6xl px-4 py-6 md:py-10">
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">Carros disponíveis</h1>
      <p className="mt-1 text-slate-500">Todos com seguro e manutenção inclusos no valor mensal.</p>

      <div className="mt-4 flex flex-wrap gap-2 md:mt-6">
        {filtros.map((f) => (
          <button
            key={f}
            onClick={() => setFiltro(f)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition ${
              filtro === f ? 'bg-brand-600 text-white shadow-sm' : 'border border-slate-300 bg-white text-slate-600 hover:border-slate-400'
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 md:mt-8 md:gap-6 lg:grid-cols-3">
        {lista.map((c) => {
          const st = STATUS[c.status]
          return (
            <Link
              key={c.id}
              to={`/carros/${c.id}`}
              className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
            >
              <div className="relative">
                <img src={c.fotos[0]} alt={c.nome} className="aspect-[4/3] w-full object-cover transition duration-500 group-hover:scale-105" />
                {c.propostas > 0 && (
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-amber-500 px-3 py-1 text-xs font-semibold text-white shadow">
                    <Flame size={13} /> Tem propostas
                  </span>
                )}
                {c.status !== 'disponivel' && (
                  <span className={`absolute right-3 top-3 rounded-full px-3 py-1 text-xs font-semibold shadow ${st.cls}`}>{st.label}</span>
                )}
                {c.consignado && (
                  <span className="absolute bottom-3 left-3 rounded-full bg-slate-900/70 px-3 py-1 text-[11px] font-medium text-white">Consignado</span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <div className="font-display font-bold text-slate-900">{c.nome}</div>
                <div className="mt-0.5 text-sm text-slate-500">{c.ano} · {km(c.kmRodados)} · {c.cambio}</div>
                <div className="mt-3 flex items-end justify-between">
                  <div>
                    <div className="text-xs text-slate-400">a partir de</div>
                    <div className="font-display text-xl font-extrabold text-brand-700">{brl(minParcela(c))}<span className="text-sm font-semibold text-slate-400">/mês</span></div>
                  </div>
                  <span className="inline-flex items-center gap-1 rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-medium text-brand-700">
                    <ShieldCheck size={12} /> tudo incluso
                  </span>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </main>
  )
}
